import { render, staticRenderFns } from "./ProjectTestGroupEdit.vue?vue&type=template&id=16ae65c6&scoped=true&"
import script from "./ProjectTestGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectTestGroupEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTestGroupEdit.vue?vue&type=style&index=0&id=16ae65c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ae65c6",
  null
  
)

export default component.exports